"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
const intl_1 = require("@kyruus/intl");
exports.messages = (0, intl_1.defineMessages)({
    infoListBoxShowMore: {
        id: 'infoListBox.showMore',
        description: 'show more CTA in list box',
        defaultMessage: 'Show More'
    },
    infoListBoxShowLess: {
        id: 'infoListBox.showLess',
        description: 'show less CTA in list box',
        defaultMessage: 'Show Less'
    },
    infoListBoxNoResults: {
        id: 'infoListBox.noResults',
        description: 'No results message in list box',
        defaultMessage: '0 results found for “{term}”'
    },
    infoListBoxClearSearch: {
        id: 'infoListBox.clearSearch',
        description: 'Clear Search CTA for list box',
        defaultMessage: 'Clear Search'
    },
    infoListBoxSearchAriaLabel: {
        id: 'infoListBox.searchAriaLabel',
        description: 'aria label for the search box in list box',
        defaultMessage: 'Start typing to search for {item}'
    }
});
//# sourceMappingURL=messages.js.map